import { render } from "./ScrumComp.vue?vue&type=template&id=06971b11"
import script from "./ScrumComp.vue?vue&type=script&lang=js"
export * from "./ScrumComp.vue?vue&type=script&lang=js"

import "./ScrumComp.vue?vue&type=style&index=0&id=06971b11&lang=css"

import exportComponent from "C:\\Users\\stage\\NetttFormApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__